<div class="tooltip-container" (mouseenter)="onShow()" (mouseleave)="onHide()">
  <span class="tooltip-target">
    <span class="info-icon">
      <img src="assets/img/images/icon-info-mortgagee.svg" />
    </span>
  </span>

  <div #tooltip class="custom-tooltip" *ngIf="show">
    Payment for this policy has been billed to your mortgage company. No action
    is needed from you unless directed by your lender.
    <span>
      <img class="tooltip-arrow" src="assets/img/images/Arrow-tooltip.svg" />

    </span>
  </div>
</div>
